var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2868 11.9862C13.2868 15.3989 10.539 18.1655 7.14962 18.1655C3.76022 18.1655 1.01221 15.3989 1.01221 11.9862C1.01221 8.57342 3.76001 5.80664 7.14962 5.80664C10.5392 5.80664 13.2868 8.57342 13.2868 11.9862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0197 11.9875C20.0197 15.1998 18.6458 17.805 16.951 17.805C15.2562 17.805 13.8823 15.1998 13.8823 11.9875C13.8823 8.7751 15.256 6.16992 16.9508 6.16992C18.6456 6.16992 20.0195 8.77427 20.0195 11.9875",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7731 11.9909C22.7731 14.8684 22.29 17.2025 21.6938 17.2025C21.0977 17.2025 20.6147 14.869 20.6147 11.9909C20.6147 9.11278 21.0979 6.7793 21.6938 6.7793C22.2897 6.7793 22.7731 9.11257 22.7731 11.9909Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.7525694dab0396cdfcffb2489a263836.svg";
export { ForwardRef as ReactComponent };